import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import { pickProductColor } from '../../../utils/shopify';
//import { StyledList } from '../../../utils/styles';

const linkResolver = require('../../../../config/linkResolver');

const StyledCollections = styled.div`
  width: 100%;
  height: auto;
  display: block;
  a {
    width: 100%;
    display: block;
    padding: 0.8rem 2.4rem;
    border-radius: 0.8rem;
    p {
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        font-size: 0.8em;
        font-weight: bold;
        opacity: 0.48;
        margin-left: auto;
        text-align: right;
      }
    }
    &:hover {
      background-color: rgba(0, 0, 0, 0.24);
      p {
        color: var(--color-primary-light);
      }
    }
  }
`;

export const ListCollections = ({ thisCollection }) => (
  <StaticQuery
    query={graphql`
      query CollectionListQuery {
        shopify {
          collections(
            first: 250
            reverse: true
            sortKey: TITLE
            query: "(Packages OR Free OR Animated OR Alerts OR Panels OR Screens OR Transitions OR Logos OR Social OR Emotes OR Badges OR Streamdeck AND NOT Diamond)"
          ) {
            edges {
              ...shopifyCollectionCard
            }
          }
        }
      }
    `}
    render={data => {
      const collectionsWithProducts = data.shopify.collections.edges.map(
        ({ node }) =>
          node.products && node.products.edges && node.products.edges.length
            ? { node, products: node.products.edges.length }
            : { node, products: 0 }
      );

      const collectionsSorted = collectionsWithProducts.sort((a, b) =>
        a.products < b.products ? 1 : -1
      );

      return (
        <StyledCollections>
          <Link to="/store" key="storepage_all">
            <p
              style={
                !thisCollection ? { color: `var(--color-primary-light)` } : null
              }
            >
              All Products
            </p>
          </Link>
          {collectionsSorted.map(({ node, products }) => {
            const quantity = products && products >= 250 ? '250+' : products;
            const hasNoProducts = quantity <= 0;

            return hasNoProducts ? null : (
              <Link to={linkResolver('collection', node.handle)} key={node.id}>
                <p
                  style={
                    thisCollection === node.handle
                      ? { color: `var(--color-primary-light)` }
                      : null
                  }
                >
                  {node.title}{' '}
                  <span
                    style={{
                      //opacity: 0.56,
                      opacity: 1,
                      color: pickProductColor(node.title).text,
                    }}
                  >
                    ( {quantity} )
                  </span>
                </p>
              </Link>
            );
          })}
        </StyledCollections>
      );
    }}
  />
);

ListCollections.propTypes = {
  thisCollection: PropTypes.string,
  naked: PropTypes.bool,
};
ListCollections.defaultProps = {
  naked: false,
};

export default ListCollections;
